import { BREAKPOINTS } from '@jouzen/ecom-components/v3/consts/breakpoints';
import type { ResponsiveType } from 'react-multi-carousel';

export const RESPONSIVE_DATA: ResponsiveType = {
  desktop: {
    breakpoint: {
      max: Infinity,
      min: BREAKPOINTS.large,
    },
    items: 3,
  },
  tablet: {
    breakpoint: {
      max: BREAKPOINTS.large,
      min: BREAKPOINTS.medium,
    },
    items: 2,
  },
  mobile: {
    breakpoint: {
      max: BREAKPOINTS.medium,
      min: 0,
    },
    items: 1,
  },
};
